<template>
  <div>
    <table-temp
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      @editTable="editTable"
      @handleSelectionChange="handleSelectionChange"
    >
      <div slot="tool">
        <el-button class="borderBtn" @click="addDialog">添加</el-button>
        <el-button class="borderBtn" @click="delProduct">删除</el-button>
      </div>
    </table-temp>
    <step-dialog
      ref="dialog"
      :dialogVisible="dialogVisible"
      :title="title"
      @closeDialog="closeDialog"
      @reload="reloadData"
      :data="commonData"
      :codeId="codeId"
      @inputChange="inputChange"
      :key="key"
    ></step-dialog>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableTemp from '@table/table'
import { step3, step3Agency } from '@/conf/Report-manager'
import StepDialog from '../dialog/step3Dialog'
import comMixin from 'common/js/mixin/comMixin'

import {
  getPreReportDetail,
  getPreProduct,
  delPreProduct,
  selectDic,
  nation,
  deleteMgrProduct,
  deleteFundInvested,
  getReportMgrProductByReportCode,
  getReportFundInvestedByReportCode
} from 'common/js/api'

export default {
  components: {
    TableTemp,
    StepDialog
  },

  mixins: [comMixin],

  data() {
    return {
      title: '添加年内拟发行产品',
      tableData: [],
      tableConf: [],
      dialogVisible: false,
      key: 0,
      isManager: true,
      codeId: this.$route.query.codeId,
      commonData: {},
      selectIds: '',
      step: 2,
      provinceOption: [],
      cityOption: [],
      districtOption: []
    }
  },

  created() {
    // 设置配环境
    this.setEnvironment()
    this.provinceOption = []
  },

  mounted() {
    this.setConf()
    this.getSelect()
    this.getNation()
    this.getProductListData()
  },

  methods: {
    //获取基金已发行产品情况
    async getProductListData() {
      console.log('getReportMgrProductByReportCode!!@@')
      const params = {
        reportCode: this.codeId
      }
      if (this.isManager) {
        const res = await getReportMgrProductByReportCode(params)
        console.log(res, 'getReportMgrProductByReportCode', res)

        this.tableData = res.result.filter(item => {
          console.log('##->', item)
          return item.productType == 0
        })
      } else {
        const res = await getReportFundInvestedByReportCode(params)
        console.log(res, 'getReportFundInvestedByReportCode', res)
        this.tableData = res.result.filter(item => {
          console.log('@@->', item)
          return item.investedType == 0
        })
      }
    },

    reloadData() {
      this.getProductListData()
    },

    handleSelectionChange(ids) {
      this.selectIds = ids
    },

    async delProduct() {
      if (!this.selectIds) {
        this.$message({
          message: '请先选择删除的列表,再点击删除!',
          type: 'warning'
        })
        return
      }
      if (this.isManager) {
        await deleteMgrProduct(this.selectIds)
      } else {
        await deleteFundInvested(this.selectIds)
      }

      this.$message({
        message: '删除成功!',
        type: 'success'
      })
      this.reloadData()
    },

    editTable(val) {
      this.title = '编辑年内拟发行产品'
      this.commonData = val.scope.row
      this.$set(this.commonData, 'dte', new Date())
      this.key++
      this.dialogVisible = true
    },

    async save() {
      return true
    },

    setEnvironment() {
      this.fillType = this.$store.state.ReportData.reportFillType
      console.log('当前的配置getFillType using', this.fillType)
      if (this.fillType == 'x') {
        this.isManager = true
      }
      if (this.fillType == 'y') {
        this.isManager = false
      }
    },

    setConf() {
      if (this.isManager) {
        this.tableConf = step3
        console.log('使用了step3')
        this.title = '添加年内拟发行产品'
      } else {
        this.tableConf = step3Agency
        console.log('使用step3Agency')
        this.title = '添加年内拟新增项'
      }
    },

    addDialog(val) {
      this.commonData = {}
      this.title = this.isManager ? '添加年内拟发行产品' : '添加年内拟完成项目投资情况'
      this.$set(this.commonData, 'dte', new Date())
      this.key++
      this.dialogVisible = true
      this.cityList = []
    },

    closeDialog() {
      this.dialogVisible = false
    },
    async getSelect() {
      const query = '5'
      const result = await selectDic(query)
      const {
        //FUND_INSTITUTION_ORIGIN,
        //FUND_PRODUCT_TYPE,
        INVEST_INDUSTRY
      } = result.result

      //this.converSelect(FUND_INSTITUTION_ORIGIN, 11);
      //this.converSelect(FUND_PRODUCT_TYPE, 3);
      if (this.isManager) {
        this.converSelect(INVEST_INDUSTRY, 3)
      } else {
        this.converSelect(INVEST_INDUSTRY, 7)
      }
    },

    async getNation() {
      const { result } = await nation(0)
      this.provinceOption = result
      let data = []
      result.forEach(element => {
        data.push({ label: element.district, value: element.district })
      })
      this.$refs.dialog.dataSource[1].options = data
    },

    converSelect(option, index) {
      console.log('%%%%->', this.tableConf)
      option.forEach(item => {
        let data = {
          label: item,
          value: item
        }
        this.tableConf[index].options.push(data)
      })
    },
    async inputChange(val) {
      if (val.key === 'registeProvince') {
        console.log('进行清除')
        this.$refs.dialog.dataSource[2].options = []
        this.$refs.dialog.dataSource[3].options = []
        let value = this.provinceOption.find(element => {
          return element.district === val.value
        })
        const { result } = await nation(value.id)
        this.cityOption = result
        let data = []
        result.forEach(element => {
          data.push({ label: element.district, value: element.district })
        })
        this.$refs.dialog.dataSource[2].options = data
        this.$refs.form.form.registeCity = ''
        this.$refs.form.form.registeDistrict = ''
      }
      if (val.key === 'registeCity') {
        console.log('registeDistrict进行清除')
        this.$refs.dialog.dataSource[3].options = []
        let value = this.cityOption.find(element => {
          return element.district === val.value
        })
        let data = []
        console.log(val, value)
        const { result } = await nation(value.id)
        this.districtOption = result
        result.forEach(element => {
          data.push({ label: element.district, value: element.district })
        })
        this.$refs.dialog.dataSource[3].options = data
        this.$refs.form.form.registeDistrict = ''
      }

      if (val.key === 'investProvince') {
        this.$refs.dialog.dataSource[2].options = []
        this.$refs.dialog.dataSource[3].options = []
        let value = this.provinceOption.find(element => {
          return element.district === val.value
        })
        const { result } = await nation(value.id)
        this.cityOption = result
        let data = []
        result.forEach(element => {
          data.push({ label: element.district, value: element.district })
        })
        this.$refs.dialog.dataSource[2].options = data
        this.$refs.dialog.$refs.form.form.investCity = ''
        this.$refs.dialog.$refs.form.form.investDistrict = ''
      }
      if (val.key === 'investCity') {
        this.$refs.dialog.dataSource[3].options = []
        let value = this.cityOption.find(element => {
          return element.district === val.value
        })
        let data = []
        console.log(val, value)
        const { result } = await nation(value.id)
        this.districtOption = result
        result.forEach(element => {
          data.push({ label: element.district, value: element.district })
        })
        this.$refs.dialog.dataSource[3].options = data
        console.log('investDistrict进行清除')
        this.$refs.dialog.$refs.form.form.investDistrict = ''
      }
    }
  }
}
</script>

<style></style>
